import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import FileLinkMessage from './popups/FileLinkMessage';


class DocketDetailsPurchaseForm extends Component {
  renderProgress = percentage => (
    <div>
      <ProgressBar percentage={percentage || 5} show />
    </div>
  )

  render() {
    const { docketParts } = this.props;
    const {
      parts_to_purchase,
      total_cost,
      parts,
      percentage,
      step,
      status,
      purchased,
      alreadyPurchased,
      link,
    } = docketParts;

    let step2 = null;

    if (step === 2 || step === 3) {
      step2 = (alreadyPurchased)
        ? (<div>Already Purchased </div>)
        : (
          <div>
            { step === 2 && this.renderProgress(percentage) }
            Purchased { purchased || 0 } / {parts.length} PDFs
          </div>
        );
    }

    const partsOrLoading = ((step === 1 || step === 0) && status === 'loading')
      ? this.renderProgress(percentage)
      : (
        <div id="progress1" className="batch-processed">
          Need to purchase { parts_to_purchase } / { parts.length } PDFs.
          { step === 1 && parts_to_purchase > 0 &&
            <button className="form-submit green next buy-btn" onClick={this.props.buy}>
              Buy ${ (total_cost || 0).toFixed(2) }
            </button>
          }
        </div>
      );

    return (
      <div className="inner-text">
        { this.props.showXfaWarning &&
          <div className="warning">
            PDF combining currently does not support XFA documents.
          </div>
        }
        <ol>
          <li className="">
            Checking price of all dockets
            { partsOrLoading }
          </li>
          <li className={(step === 1) ? 'pending' : ''}>
            Purchasing dockets
            { step2 }
          </li>
          <li className={(step === 3) ? '' : 'pending'}>
            Combining
            {(step === 3 && status !== 'done') && (
              this.renderProgress(100)
            )}
            { link && <FileLinkMessage link={link} /> }
          </li>
        </ol>

      </div>
    );
  }
}

DocketDetailsPurchaseForm.defaultProps = {
  showXfaWarning: false,
}

DocketDetailsPurchaseForm.propTypes = {
  docketParts: PropTypes.object.isRequired,
  buy: PropTypes.func.isRequired,
  showXfaWarning: PropTypes.bool,
};

export default DocketDetailsPurchaseForm;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/DocketDetailsPurchaseForm.jsx
 **/